import * as Expressions from "./expressions";
import * as Lexer from "./lexer";
import * as PrimitiveLiteral from "./primitiveLiteral";
import * as Token from "./token";
import { SourceArray } from "./utils";

interface Options {
  metadata?: Lexer.MetadataContext;
}

type ParserFn<T extends Lexer.TokenType> = (
  value: SourceArray,
  index: number,
  metadataContext?: Lexer.MetadataContext,
) => Token.TokenOfType<T> | undefined;

export const parserFactory = function <T extends Lexer.TokenType>(
  fn: ParserFn<T>,
) {
  return function (source: string, options: Options = {}) {
    const raw = new Uint16Array(source.length);
    const pos = 0;
    for (let i = 0; i < source.length; i++) {
      raw[i] = source.codePointAt(i) as number;
    }
    const result = fn(raw, pos, options.metadata);
    if (!result) {
      throw new Error(`Fail at ${pos}`);
    }
    if (result.next < raw.length) {
      throw new Error(`Unexpected character at ${result.next}`);
    }
    return result;
  };
};

/**
 * odata uri parser
 */
export class Parser {
  /**
   * parser ast node with full odata uri
   *
   * @param source
   * @param options
   */
  filter(
    source: string,
    options?: Options,
  ): NonNullable<ReturnType<typeof Expressions.boolCommonExpr>> {
    return parserFactory(Expressions.boolCommonExpr)(source, options);
  }
  literal(
    source: string,
    options?: Options,
  ): NonNullable<ReturnType<typeof PrimitiveLiteral.primitiveLiteral>> {
    return parserFactory(PrimitiveLiteral.primitiveLiteral)(source, options);
  }
}

export function filter(
  source: string,
  options?: Options,
): NonNullable<ReturnType<typeof Expressions.boolCommonExpr>> {
  return parserFactory(Expressions.boolCommonExpr)(source, options);
}
export function literal(
  source: string,
  options?: Options,
): NonNullable<ReturnType<typeof PrimitiveLiteral.primitiveLiteral>> {
  return parserFactory(PrimitiveLiteral.primitiveLiteral)(source, options);
}
